// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nbody,\nhtml,\n.app,\n#app,\nh3 {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n* {\n    margin: 0;\n    padding: 0;\n}\nbody,\nhtml {\n    width: 100%;\n    height: 100%;\n    min-width: 1200px;\n}\n.el-popper {\n    /* width: 60px     !important; */\n    min-width: 0 !important;\n}\n/* @import url('~@/assets/self-adaption.scss'); */\n\n", ""]);
// Exports
module.exports = exports;
